import React from "react";
import styled from "styled-components";
import { Cell, Row, Tooltip } from "@workboard/wobo-ui";
import { truncateWithEllipsis } from "../../../../../../utils/function";

const MAX_TEAMNAME = 200;
const MAX_MANAGERNAME = 120;

const Template = ({
  teamName,
  teamId,
  managerName,
  managerId,
  level,
  memberCount,
  okrCount,
  okrProgressPercent,
  krCount,
  krPastDueCount,
  krNeverUpdatedCount,
  okrExpiredCount,
  /* lastEngagement Post-wave63 */
  ...props
}) => (
  <Row {...props}>
    <Cell>
      <a href={`/wb/goal/teamGoal?teamId=${teamId}&js=1`} target="_blank">
        {teamName && teamName.length > MAX_TEAMNAME ? (
          <Tooltip content={teamName}>
            <span>{truncateWithEllipsis(teamName, MAX_TEAMNAME)}</span>
          </Tooltip>
        ) : (
          <span>{teamName}</span>
        )}
      </a>
    </Cell>
    <Cell>
      <a href={`/wb/memberProfile/index?id=${managerId}`} target="_blank">
        {managerName && managerName.length > MAX_MANAGERNAME ? (
          <Tooltip content={managerName}>
            <span>{truncateWithEllipsis(managerName, MAX_MANAGERNAME)}</span>
          </Tooltip>
        ) : (
          <span>{managerName}</span>
        )}
      </a>
    </Cell>
    <Cell>{level}</Cell>
    <Cell>{memberCount}</Cell>
    <Cell>{okrCount}</Cell>
    <Cell>{okrProgressPercent}%</Cell>
    <Cell>{krCount}</Cell>
    <Cell>{krPastDueCount}</Cell>
    <Cell>{krNeverUpdatedCount}</Cell>
    <Cell>{okrExpiredCount}</Cell>
    {/* <Cell>{lastEngagement.toString().slice(0, 16)}</Cell> Post-wave63 */}
  </Row>
);

export default styled(Template)`
  td {
    white-space: nowrap;
  }
`;
